<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame" id="_idContainer001">
<p class="structure-next" id="calibre_pb_2"><span class="bold1"> </span></p>
<p class="free-form1"><span class="charoverride">Live with Intention</span></p>
<p class="free-form2"><span class="charoverride1">Remember <br class="calibre1"/>and Do What Matters</span></p>
<p class="name"><span class="charoverride2">Mary Anne Radmacher</span></p>
<p class="normal"><span class="charoverride3"><img alt="" class="_idgenobjectattribute" src="OEBPS/image/ConariPress(logo)BW-01.png"/></span></p>
<p class="normal"><span class="italic1">Mango Publishing</span></p>
<p class="normal1" id="calibre_pb_3"><span class="charoverride4">Coral Gables</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// LiveWithIntention_split_001.vue?0cce5f49